import { Helmet, HelmetProvider } from "react-helmet-async";
import OutstandingCommunicationModule from "./modules/OutstandingCommunicationModule";
import NotificationsListModule from "./modules/NotificationsListModule";

/**
 * Personal notifications & actions dashboard.
 *
 * Modular by design: each concern is its own self-contained module so new
 * "outstanding action" sources can be slotted in without touching the others.
 * Currently:
 *  - OutstandingCommunicationModule: assigned helpdesk tickets with unread emails
 *  - NotificationsListModule: the user's notifications (read/unread, mark read)
 */
const NotificationsDashboard = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Meldingen & acties</title>
        </Helmet>
      </HelmetProvider>

      <div className="z-10 mb-10 flex flex-col gap-6">
        <div>
          <h1 className="text-xl font-medium text-neutral-primary">Meldingen & acties</h1>
          <p className="text-sm text-neutral-secondary-mid">
            Een overzicht van je meldingen en zaken die je aandacht vragen.
          </p>
        </div>

        <OutstandingCommunicationModule />
        <NotificationsListModule />
      </div>
    </>
  );
};

export default NotificationsDashboard;
